import { useState, useEffect, useCallback } from "react";

const CURRENT_HASH = process.env.REACT_APP_BUILD_HASH || "";

export const useVersionCheck = () => {
  const [updateAvailable, setUpdateAvailable] = useState(false);

  const checkForUpdate = useCallback(async () => {
    if (!CURRENT_HASH) return;
    try {
      const res = await fetch("/version.json", { cache: "no-store" });
      if (!res.ok) return;
      const data = await res.json();
      if (data.hash && data.hash !== CURRENT_HASH) {
        setUpdateAvailable(true);
      }
    } catch {
      // silently ignore fetch errors
    }
  }, []);

  return { updateAvailable, checkForUpdate };
};
